import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { BaseService } from '@/core/api/base-service';
import { ApiConfiguration } from '@/core/api/api-configuration';
import { ConsultorioAnotacaoCreateRequest, ConsultorioAtualizacaoRequest } from '@/core/api/sicom-api/registro/medico/consultorio-privado/consultorio-atualizacao.model';
import { Pessoa } from '@/shared/models/pessoa-info.model';
import { environment } from '@env/environment';
import { SICOM_PATHS } from 'src/sicom-paths';

@Injectable({ providedIn: 'root' })
export class ConsultorioAtualizacaoService extends BaseService {
    constructor(config: ApiConfiguration, http: HttpClient) {
        super(config, http, environment.apis.apiSicom);
    }
    readonly PATH = SICOM_PATHS.registro.medico.consultorioPrivado.atualizacaoConsulta;
    readonly PATH_ANOTACAO_CONSULTA = SICOM_PATHS.registro.medico.consultorioPrivado.anotacaoConsulta;
    readonly PATH_ANOTACAO = SICOM_PATHS.registro.medico.consultorioPrivado.anotacao;

    buscar(params: Pessoa & { idConsultorio: number }, context?: HttpContext): Observable<ConsultorioAtualizacaoRequest[]> {
        const httpParams = new HttpParams().set('id', params.id).set('uf', params.uf).set('idConsultorio', params.idConsultorio);
        return this.http.get<ConsultorioAtualizacaoRequest[]>(this.PATH, { params: httpParams, context });
    }

    buscarAnotacoes(params: Pessoa & { idConsultorio: number }, context?: HttpContext): Observable<ConsultorioAtualizacaoRequest[]> {
        const httpParams = new HttpParams().set('id', params.id).set('uf', params.uf).set('idConsultorio', params.idConsultorio);
        return this.http.get<ConsultorioAtualizacaoRequest[]>(this.PATH_ANOTACAO_CONSULTA, { params: httpParams, context });
    }

    inserirAnotacao(pessoa: Pessoa, body: ConsultorioAnotacaoCreateRequest, context?: HttpContext): Observable<void> {
        const httpParams = new HttpParams().set('id', pessoa.id).set('uf', pessoa.uf);
        return this.http.post<void>(this.PATH_ANOTACAO, body, { params: httpParams, context });
    }
}
